const ROOT_SELECTOR = '.site-header-root';
const HEADER_SELECTOR = '[data-site-header]';
const DRAWER_SELECTOR = '[data-site-header-drawer]';
const TOGGLE_SELECTOR = '[data-site-header-toggle]';
const SCROLL_THRESHOLD = 16;

export function initSiteHeader(): void {
  document.querySelectorAll<HTMLElement>(ROOT_SELECTOR).forEach(initSiteHeaderRoot);
}

function initSiteHeaderRoot(root: HTMLElement): void {
  const header = root.querySelector<HTMLElement>(HEADER_SELECTOR);
  const drawer = root.querySelector<HTMLElement>(DRAWER_SELECTOR);
  const toggles = root.querySelectorAll<HTMLButtonElement>(TOGGLE_SELECTOR);

  if (!header || !drawer || !toggles.length) return;

  let menuScrollY = 0;

  function setScrolled(): void {
    if (document.body.classList.contains('site-header-menu-open')) return;
    header.classList.toggle('site-header--scrolled', window.scrollY > SCROLL_THRESHOLD);
  }

  function setMenuOpen(isOpen: boolean): void {
    const wasOpen = document.body.classList.contains('site-header-menu-open');

    if (isOpen && !wasOpen) {
      menuScrollY = window.scrollY;
      document.body.style.top = `-${menuScrollY}px`;
    } else if (!isOpen && wasOpen) {
      document.body.style.top = '';
      window.scrollTo(0, menuScrollY);
    }

    document.documentElement.classList.toggle('site-header-menu-open', isOpen);
    document.body.classList.toggle('site-header-menu-open', isOpen);
    drawer.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

    toggles.forEach((toggle) => {
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  setScrolled();
  window.addEventListener('scroll', setScrolled, { passive: true });

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      setMenuOpen(!document.body.classList.contains('site-header-menu-open'));
    });
  });

  drawer.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => setMenuOpen(false));
  });

  window.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      setMenuOpen(false);
    }
  });
}
